// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.has-no-license-message{display:flex;justify-content:space-between}`, "",{"version":3,"sources":["webpack://./app/new-components/RequestLicenses/RequestLicensesInlineMessage.scss"],"names":[],"mappings":"AAAA,wBACE,YAAA,CACA,6BAAA","sourcesContent":[".has-no-license-message {\n  display: flex;\n  justify-content: space-between;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
